import React, { useState } from "react";
import { deliveryDayDate, filterLanded } from "../lib/columnFilter";
import { MOVES_IN_PROGRESS_FILTERS, completedMoves, movesInProgressFiltered } from "../lib/movesProgress";
import { useMcOps } from "../lib/McOpsContext";
import {
  ColumnFilter,
  EscalationCard,
  KanbanColumn,
  StatCard,
} from "../components/Common";
import { BoardTitleRow } from "../components/JobSearch";

export const MovesProgressPage = () => {
  const { state, toggleEscalation, openJob } = useMcOps();

  // Moves in Progress: Today (the moves happening now) / Next 7 days (about to
  // start) / All. The other columns filter by the day a job landed in them.
  const [filters, setFilters] = useState({
    inProgress: "today",
    deliveryDay: "all",
    escalations: "all",
    openEscalations: "all",
    completed: "all",
  });
  const filterFor = (column) => (
    <ColumnFilter
      value={filters[column]}
      onChange={(key) => setFilters((prev) => ({ ...prev, [column]: key }))}
    />
  );

  const inProgress = movesInProgressFiltered(state, filters.inProgress);
  const deliveryDayLocal = filterLanded(
    state.jobs.filter(
      (j) =>
        j.moveType === "ld" &&
        j.status === "ld-delivery-local" &&
        !j.deliveryDayCompleted,
    ),
    filters.deliveryDay,
    undefined,
    deliveryDayDate,
    true,
  );
  const opsEsc = filterLanded(
    state.escalations.filter((e) => e.type === "ops"),
    filters.escalations,
    undefined,
    (e) => e.createdAt,
  );
  const completed = filterLanded(completedMoves(state), filters.completed);
  // Every open escalation raised during a move, either team, newest first.
  const openEsc = filterLanded(
    state.escalations.filter((e) => e.status === "open"),
    filters.openEscalations,
    undefined,
    (e) => e.createdAt,
  ).sort((a, b) => String(b.createdAt).localeCompare(String(a.createdAt)));
  const openEscalationJob = (e) => {
    const j = state.jobs.find((x) => x.id === e.jobId);
    openJob(e.jobId, j && j.moveType === "ld" ? "s3p" : "s4");
  };

  return (
    <div className="page active">
      <BoardTitleRow title="Moves in Progress" />

      <div className="counter-row cols-5">
        <StatCard icon="activity" color="blue" num={inProgress.length} label="Moves In Progress" />
        <StatCard icon="truck" color="amber" num={deliveryDayLocal.length} label="Delivery Day in Progress" />
        <StatCard icon="alert" color="red" num={opsEsc.length} label="Operations Escalation" />
        <StatCard icon="alert" color="red" num={openEsc.length} label="Open Escalations" />
        <StatCard icon="check" color="green" num={completed.length} label="Move In Progress Completed" />
      </div>

      <div className="kanban cols-5">
        <KanbanColumn
          title="Moves in Progress"
          jobs={inProgress}
          color="var(--primary)"
          tab={(j) => (j.moveType === "ld" ? "s3p" : "s4")}
          hideCount
          emptyLabel="No moves today"
          toolbar={
            <ColumnFilter
              options={MOVES_IN_PROGRESS_FILTERS}
              value={filters.inProgress}
              onChange={(key) => setFilters((prev) => ({ ...prev, inProgress: key }))}
            />
          }
        />
        <KanbanColumn
          title="Delivery Day in Progress"
          jobs={deliveryDayLocal}
          color="var(--warning)"
          tab="s4"
          hideCount
          emptyLabel="No moves today"
          toolbar={filterFor("deliveryDay")}
        />
        <KanbanColumn
          title="Operations Escalation"
          jobs={opsEsc}
          color="var(--danger)"
          hideCount
          emptyLabel="None"
          toolbar={filterFor("escalations")}
          renderItem={(e) => (
            <EscalationCard escalation={e} onToggle={toggleEscalation} key={e.id} />
          )}
        />
        <KanbanColumn
          title="Open Escalations"
          jobs={openEsc}
          color="var(--danger)"
          hideCount
          emptyLabel="No open escalations"
          toolbar={filterFor("openEscalations")}
          renderItem={(e) => (
            <EscalationCard
              escalation={e}
              onToggle={toggleEscalation}
              onOpenJob={openEscalationJob}
              key={e.id}
            />
          )}
        />
        <KanbanColumn
          title="Move in Progress Completed"
          jobs={completed}
          color="var(--success)"
          tab="s5"
          hideCount
          emptyLabel="None yet"
          toolbar={filterFor("completed")}
        />
      </div>
    </div>
  );
};
